import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addAdvertiser, updAdvertiser } from "@/api/Administration/advertiser";
export default {
  data: function data() {
    return {
      paramesData: {
        id: '',
        ad_id: '',
        ad_name: ''
      },
      dialogFormVisible: false,
      rules: {
        ad_name: [{
          required: true,
          message: "请输入广告主名称",
          trigger: "blur"
        }],
        ad_id: [{
          required: true,
          message: "请输入广告主ID",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (data) {
                  _this.paramesData = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm() {
      this.dialogFormVisible = false;
      this.clearData();
      this.$emit("change", false);
    },
    clearData: function clearData() {
      this.paramesData = {
        id: '',
        ad_id: '',
        ad_name: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          var reqFn = _this2.paramesData.id ? updAdvertiser : addAdvertiser;
          reqFn(_this2.paramesData).then(function (res) {
            if (res.status == 200) {
              _this2.$message.success('操作成功');

              _this2.dialogFormVisible = false;

              _this2.$emit("change");
            }
          });
        }
      });
    }
  }
};